import { MetricMap } from '@core/models/metric.models'
import { SpiderChartData } from '@shared/components/spider-chart/models/spider-chart.models'

export const parseSpiderChartDatasource = (metrics: MetricMap): SpiderChartData[] =>
  (metrics?.chartMetricResults || []).reduce(
    (arr, metricItem) => [
      ...arr,
      {
        keys: [metricItem.key],
        values: [(metricItem.leftMetricResult || {}).value, (metricItem.rightMetricResult || {}).value],
        attributes: metricItem.attributes
      }
    ],
    []
  )

export const closestTicks = (axisScale: any, tickNumber: any, getTickArray = false) => {
  let tickNum = tickNumber
  let tickLength = 0
  let ticks: number[] = []
  do {
    ticks = (axisScale.scale ? axisScale.scale() : axisScale).ticks(tickNum--)
    tickLength = ticks.length
  } while (tickLength > tickNumber)

  return getTickArray ? ticks : tickNum + 1
}
